// 运营-电站api
import request from "@/util/request";
import axios from "axios";
const CancelToken = axios.CancelToken;
let cancel;
export function cancelRequest() {
	if (typeof cancel === "function") {
		// 取消请求
		cancel();
	}
}
export function apiGetList(params, data) {
	// 电站列表
	return request({
		url: `/maintain-s/operating/station/search`,
		method: "post",
		params,
		data,
	});
}
/////////////////////////////////////////地图模式
export function apiGetListForMapMode(params, data) {
	// 电站列表for地图模式
	return request({
		url: `/maintain-s/operating/station/stationView/search`,
		method: "post",
		params,
		data,
	});
}
export function apiGetPlantDetailByMap(id) {
	//电站详情for地图模式
	return request({
		url: `/maintain-s/station/${id}/summary`,
		method: "get",
	});
}
export function apiGetPlantDetailDeviceByMap(id) {
	//电站详情中的设备for地图模式
	return request({
		url: `/maintain-s/operating/system/${id}/summary`,
		method: "get",
	});
}
export function apiGetPlantDetailAlarmByMap(id, startTime, endTime) {
	//电站详情中的报警for地图模式
	return request({
		url: `/maintain-s/operating/alert/search`,
		method: "post",
		params: {
			"order.direction": "DESC",
			"order.property": "alertTime",
			size: 1,
			page: 1,
		},
		data: {
			plantId: id,
			language: stage.languageId,
			startTime,
			endTime,
		},
	});
}
export function apiGetPlantOutRole(id) {
	//查询电站的外部权限
	return request({
		url: `/maintain-s/station/${id}/outRole`,
		method: "get",
	});
}

export function apiGetListFull(params) {
	//大屏
	return request({
		url: `/maintain-s/operating/station/screen/search`,
		method: "get",
		params,
	});
}
// 电站系统详情头信息
export function OperationHeadInfo(id) {
	return request({
		url: `/maintain-s/operating/station/${id}`,
		method: "get",
	});
}
// 电站详情的系统摘要
export function StationSummary(id, params) {
	return request({
		url: `/maintain-s/operating/system/${id}/summary`,
		method: "get",
		params,
	});
}

///////////////////////////////////////////////////////////////照片系列
export function apiGetPlantPhotoList(id) {
	//获取电站照片列表
	return request({
		url: `/maintain-s/station/${id}/images`,
		method: "get",
		params: {
			"order.direction": "DESC", //ASC
			"order.property": "id",
			page: 1,
			size: 50,
		},
	});
}
export function apiNewPhoto(data) {
	//添加电站照片
	return request({
		url: `/maintain-s/station/image`,
		method: "post",
		data,
	});
}
export function apiEditPhoto(data) {
	//编辑电站照片
	return request({
		url: `/maintain-s/station/image/${data.id}`,
		method: "post",
		data,
	});
}
export function apiDeletePhoto(id) {
	//删除电站照片
	return request({
		url: `/maintain-s/station/image/${id}`,
		method: "delete",
	});
}

// 日曲线
export function PowerDayHistory(id, date) {
	return request({
		url: `/maintain-s/history/power/${id}/record`,
		method: "get",
		params: date,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 日曲线温度-天气
export function WeatherDayHistory(params) {
	return request({
		url: `/weather-s/weather/record/day`,
		method: "get",
		params,
	});
}
// 月曲线温度-天气
export function WeatherMonthHistory(params) {
	return request({
		url: `/weather-s/weather/record/month`,
		method: "get",
		params,
	});
}
// 月统计历史
export function PowerMonthHistory(id, data) {
	return request({
		url: `/maintain-s/history/power/${id}/stats/month`,
		method: "get",
		params: data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 季统计历史
export function PowerQuarterHistory(id, year, quarter) {
	return request({
		url: `/maintain-s/history/power/${id}/stats/quarter?year=${year}&quarter=${quarter}`,
		method: "get",
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 年统计历史
export function PowerYearHistory(id, data) {
	return request({
		url: `/maintain-s/history/power/${id}/stats/year`,
		method: "get",
		params: data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 总统计历史
export function PowerTotalHistory(id, data) {
	return request({
		url: `/maintain-s/history/power/${id}/stats/total`,
		method: "get",
		params: data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 父系统查看设备列表(采集器)
export function OperationCollector(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/collector`,
		method: "get",
		params: data,
	});
}
// 子系统查看设备列表(采集器)
export function OperationChildCollector(id, data) {
	return request({
		url: `/maintain-s/operating/station/sub_system/${id}/collector`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(组件)
export function OperationComponet(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/module`,
		method: "get",
		params: data,
	});
}
// 子系统查看设备列表(组件)
export function OperationChildComponet(id, data) {
	return request({
		url: `/maintain-s/operating/station/sub_system/${id}/componet`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(电表)
export function OperationAmmeter(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/meter`,
		method: "get",
		params: data,
	});
}
// 子系统查看设备列表(电表)
export function OperationChildAmmeter(id, data) {
	return request({
		url: `/maintain-s/operating/station/sub_system/${id}/electricMeter`,
		method: "get",
		params: data,
	});
}

// 父系统查看设备列表(逆变器)
export function OperationInverter(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/inverter`,
		method: "get",
		params: data,
	});
}
export function OperationtypeOffGridInverter(id, data) {
	//离网逆变器
	// return request({
	// 	url: `/maintain-s/operating/station/${id}/typeOffGridInverter`,
	// 	method: 'get',
	// 	params: data
	// })
}
// 子系统查看设备列表(逆变器)
export function OperationChildInverter(id, data) {
	return request({
		url: `/maintain-s/operating/station/sub_system/${id}/inverter`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(气象站)
export function OperationWeather(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/weather`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(微逆)
export function OperationMicroInverter(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/microInverter`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(汇流箱)
export function OperationCombinerBox(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/combinerBox`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(中继器)
export function OperationRepeater(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/repeater`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(电池)
export function OperationBattery(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/battery`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(DTU)
export function OperationDTU(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/DTU`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(API)
export function OperationAPI(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/API`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(FAN)
export function OperationFAN(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/fan`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(EPM)
export function OperationEPM(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/epm`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(HYBRID_POWER_SYSTEM_CABINET)
export function OperationHybridPower(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/hybridPower`,
		method: "get",
		params: data,
	});
}
// 父系统查看设备列表(SMART_METER)
export function OperationSmartMeter(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/smartMeter`,
		method: "get",
		params: data,
	});
}

export function OperationCommon(id, data) {
	return request({
		url: `/maintain-s/operating/station/${id}/common`,
		method: "get",
		params: data,
	});
}

export function apiNewPlant(data, id, params) {
	// 创建、编辑电站
	return request({
		url: `/maintain-s/station` + (id ? "/" + id : ""),
		method: "post",
		data,
		params,
	});
}
export function apiGetStatusCount(data) {
	// 电站统计{nationId,tagId}
	return request({
		url: `/maintain-s/operating/station/status/counting`,
		method: "get",
		params: data, // $.param(data)
	});
}

export function apiSetFollow(data, isFollow) {
	// 电站关注
	return request({
		url: `/maintain-s/station/follow`,
		method: isFollow ? "post" : "delete",
		data, // $.param(data)
	});
}

// 删除电站
export function apiDeletePlant(data) {
	return request({
		url: `/maintain-s/station`,
		method: "delete",
		data: data,
	});
}

export function apiAddPerson(data) {
	// 电站中添加关联人
	return request({
		url: `/maintain-s/station/assignment/member`,
		method: "post",
		data,
	});
}

export function apiReplaceDevice(stationId, deviceId, data) {
	// 电站中替换设备
	return request({
		url: `/maintain-s/power/system/${stationId}/device/${deviceId}`,
		method: "post",
		data,
	});
}

export function apiGetPlantDetail(id, params) {
	// 获取电站详细信息（数据格式和创建电站相同）
	return request({
		url: `/maintain-s/station/${id}/detail`,
		method: "get",
		params,
	});
}

export function apiCanAddToStation(id, sensor, sn) {
	// 获取电站详细信息（数据格式和创建电站相同）
	return request({
		url: `/maintain_old/station/${id}/device/${sensor}/${sn}`,
		method: "get",
	});
}

// 获取指定电站运营信息
export function StationInfo(id) {
	return request({
		url: `/maintain-s/operating/system/${id}`,
		method: "get",
	});
}

// 电站基本信息
export function StationBasicInfo(id) {
	return request({
		url: `/maintain-s/station/${id}`,
		method: "get",
	});
}
// 电站成本，效益等信息
export function StationCost(id) {
	return request({
		url: `/maintain-s/station/${id}/finance`,
		method: "get",
	});
}
// 电站和子系统发电实时
export function GeneratePower(id) {
	return request({
		url: `/maintain-s/operating/station/${id}/realTimePowerGenerationInfo `,
		method: "get",
	});
}
// 电站和子系统用电实时
export function UsePower(id) {
	return request({
		url: `/maintain-s/operating/station/${id}/realTimePowerUseInfo `,
		method: "get",
	});
}
// 电站和子系统流程图
export function FlowChart(id) {
	return request({
		url: `/maintain-s/operating/station/${id}/realTimeElictricInfo `,
		method: "get",
	});
}
// 电站和子系统电网实时
export function GridPower(id) {
	return request({
		url: `/maintain-s/operating/station/${id}/realTimeGridElectricQuantityInfo`,
		method: "get",
	});
}

// 查看关联人员列表
export function AssociatedPerson(id, param) {
	return request({
		url: `/maintain-s/station/${id}/assignment/member`,
		method: "get",
		params: param,
	});
}
// 关联人员解除关联
export function AssociatedPersonDel(id, watcherId) {
	return request({
		url: `/maintain-s/station/${id}/assignment/member/${watcherId}`,
		method: "delete",
	});
}

// 当前电站下有未设置电表提醒
export function MeterUnconfigured(id) {
	return request({
		url: `/maintain-s/power/system/${id}/meter/unconfigured`,
		method: "get",
		// params: data
	});
}
// 采集器下逆变器状态
export function OperationCollectorStatus(id, data) {
	return request({
		url: `/maintain_old/operation/collector/${id}/inverter`,
		method: "get",
		params: data,
	});
}
// 设备删除（采集器）
export function OperationDelete(systemId, data) {
	return request({
		url: `/maintain-s/power/system/${systemId}/device`,
		method: "delete",
		data,
	});
}
// 设备删除（非采集器）
export function OperationDelete_equipment(stationId, deviceId) {
	return request({
		url: `/maintain_old/operation/station/${stationId}/device/${deviceId}`,
		method: "delete",
	});
}
// 电站信息配置
export function StationMetering(id) {
	return request({
		url: `/maintain-s/station/${id}/metering`,
		method: "get",
	});
}
// 更新测量配置信息
export function StationMeteringSetting(id, data) {
	return request({
		url: `/maintain-s/station/${id}/metering`,
		method: "post",
		data,
	});
}
//修改累计电量计算方法-2020.2.24
export function StationMeteringMethod(id, data) {
	return request({
		url: `/maintain-s/station/${id}/meteringMethod`,
		method: "post",
		data,
	});
}
// 数据来源设置
export function StationMeteringStrategy(id, data) {
	return request({
		url: `/maintain-s/station/${id}/metering/strategy`,
		method: "post",
		params: data,
	});
}
// 消息列表
export function getInbox() {
	return request({
		url: `/maintain_old/inbox`,
		method: "get",
	});
}
// 清空列表
export function deleteInbox() {
	return request({
		url: `/maintain_old/inbox`,
		method: "delete",
	});
}
// 标记已读
export function readInbox(id) {
	return request({
		url: `/maintain_old/inbox/read/${id}`,
		method: "post",
	});
}
// 添加標簽
export function ApiaddTag(id) {
	return request({
		url: `/maintain_old/station/${id}/addTag`,
		method: "post",
	});
}
// 查询关注
export function PostFollow(id) {
	return request({
		url: `/maintain-s/station/${id}/follow`,
		method: "get",
	});
}
/** *************************************添加直连设备********************************************/
// 获取品牌
export function AddBrand(data) {
	return request({
		url: `/product-s/product/brand`,
		method: "post",
		data,
	});
}
// 获取品牌下产品
export function AddBrandPro(params) {
	return request({
		url: `/product-s/product/list`,
		method: "get",
		params,
	});
}
// 电站中添加设备
export function apiAddDevice(id, data) {
	return request({
		url: `/maintain-s/power/system/${id}/device`,
		method: "post",
		data,
	});
}
// 获取关联设备，查询是否已经添加
export function verifyDevice(ids) {
	return request({
		url: `/maintain-s/operating/station/${ids.stationId}/device/gateway/${ids.sn}`,
		method: "get",
	});
}

// 查询直连设备子设备
export function GetSystemDevice(sn, data) {
	return request({
		url: `/maintain-s/power/system/gateway/${sn}/device`,
		method: "get",
		params: data,
	});
}
export function GetSnDevice(sensorId, snId) {
	return request({
		url: `/maintain-s/power/system/device/${sensorId}/${snId}`,
		method: "get",
	});
}
// 批量添加直连设备
export function PostGateway(id, params, data) {
	return request({
		url: `/maintain-s/power/system/${id}/gateway`,
		method: "post",
		params,
		data,
	});
}
// 获取直连设备列表
export function GetGateway(id) {
	return request({
		url: `/maintain-s/power/system/${id}/gateway`,
		method: "get",
	});
}

/** ***********************************电站运营子系统*******************************************/
// 子系统树状结构
export function StationStructure(id) {
	return request({
		url: `/maintain-s/operating/system/${id}/tree`,
		method: "get",
	});
}

// 添加子系统
export function AddChildSys(id, data) {
	return request({
		url: `/maintain-s/station/${id}/system`,
		method: "post",
		data,
	});
}
// 获取子系统设备
export function getChildSys(id) {
	return request({
		url: `/maintain-s/system/${id}`,
		method: "get",
	});
}
// 编辑子系统设备
export function EditChildSys(id, data) {
	return request({
		url: `/maintain-s/system/${id}`,
		method: "post",
		data,
	});
}
// 删除子系统
export function DeleteChildSys(id) {
	return request({
		url: `/maintain-s/system/${id}`,
		method: "delete",
	});
}
// 批量选择系统
export function PostDeviceBath(id, data) {
	return request({
		url: `/maintain-s/power/system/${id}/device/batch`,
		method: "post",
		data,
	});
}
// 储能日统计
export function batteryDailyHistory(id, data) {
	return request({
		url: `/maintain-s/history/batteryPower/${id}/stats/daily`,
		method: "get",
		params: data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}

// 储能月统计
export function batteryMonthHistory(id, data) {
	return request({
		url: `/maintain-s/history/batteryPower/${id}/stats/month`,
		method: "get",
		params: data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}

// 储能年统计
export function batteryYearHistory(id, data) {
	return request({
		url: `/maintain-s/history/batteryPower/${id}/stats/year`,
		method: "get",
		params: data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}
// 储能总统计
export function batteryTotalHistory(id, data) {
	return request({
		url: `/maintain-s/history/batteryPower/${id}/stats/total`,
		method: "get",
		params: data,
		cancelToken: new CancelToken(function executor(c) {
			cancel = c;
		}),
	});
}

// 获取设备配置信息
export function deviceConfig(stationId, data) {
	return request({
		url: `/maintain-s/operating/station/${stationId}/device-config`,
		method: "post",
		data,
	});
}

// 获取电站报警
export function getAram(data, params) {
	return request({
		url: `/maintain-s/operating/alert/search`,
		method: "post",
		params,
		data,
	});
}
// 储能电站实时流动图
export function getbatterMicro(id) {
	return request({
		url: `/maintain-s/power/system/${id}/batter/micro`,
		method: "get",
	});
}

// 更新电站的授权开关
export function authorize(stationId, params) {
	return request({
		url: `/maintain-s/station/${stationId}/auth/config`,
		method: "post",
		params,
	});
}

// 查询电站授权设置
export function getDeviceStatus(deviceId) {
	return request({
		url: `/maintain-s/device/${deviceId}/apply/status`,
		method: "get",
	});
}



// WEBPACK FOOTER //
// ./src/api/maintain/plant/list.js